module.exports = __webpack_public_path__ + "static/media/redeemVitalPoints2.76357b6a.png";